"use strict";

// dashToMinus :: String -> String
function dashToMinus(input) {
  // You may not notice the difference in monospaced font
  return input.replace('-', '−');
} // splitParts :: String -> String


function splitParts(string) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (string === '') {
    return dashToMinus(result.trim());
  }

  return splitParts(string.slice(0, -3), "".concat(string.slice(-3), " ").concat(result));
} // toIntFloat :: Number -> [String]


function toIntFloat(number, _fixed) {
  var fixed = _fixed && typeof _fixed === 'boolean' ? 2 : _fixed;
  var string = parseInt(fixed, 10) ? Math.floor(number).toFixed(fixed) : String(number);
  return string.split('.');
} // formatPrice :: Number -> String


function formatPrice(input, fixed) {
  if (typeof input !== 'number') {
    throw new Error('Must be a Number');
  }

  var arr = toIntFloat(input, fixed);
  return arr[1] ? "".concat(splitParts(arr[0]), ".").concat(arr[1]) : splitParts(arr[0]);
}

module.exports = formatPrice;